import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import withSounds from 'containers/withSounds';
import WindCreekIcon from 'components/WindCreekIcon';
import WStoreIcon from './assets/Button-WStore.svg';
import './WStoreButton.css';

class WStoreButton extends PureComponent {
  render() {
    const { onClick, to, useIcon, className } = this.props;
    const ButtonComponent = to ? Link : 'button';

    const icon = useIcon ? (
      <img src={WStoreIcon} alt="View WStore" />
    ) : (
      <WindCreekIcon className="icon-white icon-size-20" alt="W" />
    );

    const button = (
      <ButtonComponent
        className={`wstore-button ${!useIcon ? 'btn button-color-green' : ''} ${
          className || ''
        }`}
        onClick={onClick}
        to={to}
        type={to ? undefined : 'button'}
      >
        {icon}
        {!useIcon && 'Store'}
      </ButtonComponent>
    );

    if (useIcon) {
      return (
        <div className={`wstore-button-container ${className || ''}`}>
          {button}
          <span className="wstore-button-label">WStore</span>
        </div>
      );
    } else {
      return button;
    }
  }
}

WStoreButton.propTypes = {
  onClick: PropTypes.func,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object])
};

export default withSounds({ mouseEnterSound: true })(WStoreButton);
